<template>
  <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg">
    <g transform="translate(2 5)" fill-rule="nonzero" fill="none">
      <path d="M22 9V2a2 2 0 0 0-2-2H2a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12"
            :stroke="color"
            stroke-width="1.5"
            stroke-linecap="round"/>
      <g transform="translate(16 10)" :fill="color">
        <rect y="3" width="7" height="1.5" rx=".75"/>
        <rect transform="rotate(90 3.5 3.75)" y="3" width="7" height="1.5" rx=".75"/>
      </g>
      <path d="M0 12.25h6.5a3.5 3.5 0 0 0 0-7H0" :stroke="color" stroke-width="1.5"/>
      <circle :fill="color" cx="6.5" cy="8.75" r="1.5"/>
    </g>
  </svg>
</template>

<script>
  export default {
    name: "IconWallet",
    props: {
      color: {
        default: '#394BE5',
      },
    }
  }
</script>

<style scoped>

</style>